import { supabase } from '../lib/supabase';

class ClientService {
  // Get all clients
  async getAllClients() {
    try {
      const { data, error } = await supabase?.from('clients')?.select('*')?.order('created_at', { ascending: false });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error fetching clients:', error);
      return { data: null, error: error?.message };
    }
  }

  // Get client by ID
  async getClientById(id) {
    try {
      const { data, error } = await supabase?.from('clients')?.select('*')?.eq('id', id)?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error fetching client:', error);
      return { data: null, error: error?.message };
    }
  }

  // Create new client
  async createClient(clientData) {
    try {
      const { data, error } = await supabase?.from('clients')?.insert([{
          company_name: clientData?.companyName,
          contact_person: clientData?.contactPerson,
          email: clientData?.email,
          phone: clientData?.phone,
          address: clientData?.address,
          industry: clientData?.industry,
          company_size: clientData?.companySize,
          tax_id: clientData?.taxId,
          billing_address: clientData?.billingAddress,
          notes: clientData?.notes,
          status: clientData?.status || 'active'
        }])?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error creating client:', error);
      return { data: null, error: error?.message };
    }
  }

  // Update client
  async updateClient(id, clientData) {
    try {
      const updateData = {
        company_name: clientData?.companyName,
        contact_person: clientData?.contactPerson,
        email: clientData?.email,
        phone: clientData?.phone,
        address: clientData?.address,
        industry: clientData?.industry,
        company_size: clientData?.companySize,
        tax_id: clientData?.taxId,
        billing_address: clientData?.billingAddress,
        notes: clientData?.notes,
        status: clientData?.status,
        updated_at: new Date()?.toISOString()
      };

      const { data, error } = await supabase?.from('clients')?.update(updateData)?.eq('id', id)?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error updating client:', error);
      return { data: null, error: error?.message };
    }
  }

  // Delete client
  async deleteClient(id) {
    try {
      const { error } = await supabase?.from('clients')?.delete()?.eq('id', id);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error deleting client:', error);
      return { error: error?.message };
    }
  }

  // Get projects for a client
  async getClientProjects(clientId) {
    try {
      const { data, error } = await supabase?.from('projects')?.select('*')?.eq('client_id', clientId)?.order('created_at', { ascending: false });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error fetching client projects:', error);
      return { data: null, error: error?.message };
    }
  }
}

export default new ClientService();